<div class="ne-container {outroClass}"
     in:customFly="{enter}"
     out:customFly="{exit}"
     on:outrostart="{() => outroClass = 'outro'}"
     on:outroend="{() => outroClass = ''}" >
  <ConfirmPage
    forward="{forward}"
    back="{back}"
    forwardText="{$store.externalActions.forwardText.state}"
    backText="← Editor"
  />
</div>

<style>
  .ne-container {
    height: 100%;
    width: 100%;
  }

  .outro {
    height: 0;
  }
</style>

<script>
  import { store, save, router } from '../stores';
  import ConfirmPage from '../pages/ConfirmPage.html';
  import { customFly } from '../lib/transitions';

  let enter = { x: 200, duration: 350, delay: 251 };
  let exit = { x: 200, duration: 350 };
  let outroClass = '';

  function back() {
    router.set($router.to('edit'));
  }

  async function forward() {
    const response = await save();
    const opts = {
      text: $store.getText,
      noteResourceId: $store.noteResourceId.state
    };
    return response
      ? $store.externalActions.forward(opts)
      : false;
  };
</script>
